import Api from "../../Api";

export const createDailyPlannerData = async (data) => {
  try {
    let res = await Api.post("/daily-planner", data);
    return res?.data;
  } catch (e) {
    return { error: "Something Wrong" };
  }
};
export const createDailyPlanner = async (data) => {
  try {
    let res = await Api.post("/daily-planner", data);
    return res?.data;
  } catch (e) {
    return { error: "Something Wrong" };
  }
};

export const createDailyPlannerPages = async (data) => {
  try {
    let res = await Api.post("/daily-planner/add-pages", data);
    return res?.data;
  } catch (e) {
    return { error: "Something Wrong" };
  }
};
export const duplicateDailyPlannerPages = async (data) => {
  try {
    let res = await Api.post("/daily-planner/duplicate-planner", data);
    return res?.data;
  } catch (e) {
    return { error: "Something Wrong" };
  }
};

export const getDailyPlannerData = async (query) => {
  try {
    let res = await Api.get("/daily-planner", {
      params: query,
    });

    return res?.data || [];
  } catch (e) {
    return { error: "Something Wrong" };
  }
};
export const getSingleDailyPlannerData = async (query) => {
  try {
    let res = await Api.get("/daily-planner/ship-pages", {
      params: query,
    });

    return res?.data || [];
  } catch (e) {
    return { error: "Something Wrong" };
  }
};
export const getTargetedSailing = async (query) => {
  try {
    let res = await Api.get("/daily-planner/target-planners", {
      params: query,
    });
    

    return res?.data || [];
  } catch (e) {
    return { error: "Something Wrong" };
  }
};

export const getSingleWeeklyPlannerData = async (id) => {
  try {
    let res = await Api.get("/daily-planner/weekly-schedule/" + id);

    return res?.data || [];
  } catch (e) {
    return { error: "Something Wrong" };
  }
};

export const exportDailyPlannerData = async (query) => {
  try {
    let res = await Api.get("/daily-planner/export", {
      responseType: "arraybuffer",
    });

    return res?.data || [];
  } catch (e) {
    return { error: "Something Wrong" };
  }
};

export const deleteDailyPlannerData = async (id) => {
  try {
    let res = await Api.delete("/daily-planner/page-schedule/" + id);

    return res?.data || [];
  } catch (e) {
    return { error: "Failed to delete" };
  }
};

export const deleteDailyPlanner = async (vesselId, id) => {
  try {
    let res = await Api.delete(`/daily-planner/planner/${vesselId}/${id}`);

    return res?.data || [];
  } catch (e) {
    return { error: "Failed to delete" };
  }
};

export const updateDailyPlannerData = async (id, data) => {
  try {
    let res = await Api.patch("/daily-planner/" + id, data);

    return res?.data || [];
  } catch (e) {
    return { error: "Failed to Update" };
  }
};

export const addExtraDays = async (data) => {
  try {
    let res = await Api.patch("/daily-planner/extra-days", data);
    return res?.data;
  } catch (e) {
    return { error: "Failed to add extra days" };
  }
};

export const bulkDeletePageSchedule = async (data) => {
  try {
    let res = await Api.delete("/daily-planner/bulk-page-schedule", { data });
    return res?.data;
  } catch (e) {
    return { error: "Failed to delete page schedules" };
  }
};

export const checkPlannerPages = async (sourcePlannerId, targetPackageId) => {
  try {
    let res = await Api.get(
      `/daily-planner/check-planner-pages/${sourcePlannerId}/${targetPackageId}`
    );
    return res?.data;
  } catch (error) {
    return { error: "Something Wrong" };
  }
};
